/**
 * Format time_slots_by_day (from GET v2/weekly_availabilities?general_availability=true)
 * to a single human-readable string. Plan §2.1; same format as webaiwidgetmgr.
 * Day order: Sunday (0) … Saturday (6). Closed = "Closed"; open = "DayName: 09:00–17:00".
 * Collapses consecutive days with same slots (e.g. "Monday–Friday: 09:00–17:00").
 * Each day or group of days is on its own line (newline-separated).
 *
 * @param {Array<{ day: number, enabled: boolean, slots: Array<{ start_time: string, end_time: string }> }>} timeSlotsByDay
 * @returns {string}
 */
function formatTimeSlotsByDayToHumanReadable(timeSlotsByDay) {
  const DAY_NAMES = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const sorted = [...(timeSlotsByDay ?? [])].sort((a, b) => (a.day ?? 0) - (b.day ?? 0));
  const parts = [];
  for (let i = 0; i < sorted.length; i += 1) {
    const d = sorted[i];
    const dayNum = d.day ?? i;
    const dayName = DAY_NAMES[dayNum] ?? `Day ${dayNum}`;
    const slotStr = !d.enabled || !Array.isArray(d.slots) || d.slots.length === 0
      ? 'Closed'
      : d.slots
        .map((s) => `${(s.start_time ?? '').trim()}–${(s.end_time ?? '').trim()}`)
        .filter((s) => s !== '–')
        .join(', ');
    if (parts.length > 0 && parts[parts.length - 1].endsWith(`: ${slotStr}`)) {
      const last = parts[parts.length - 1];
      const dayPart = (last.split(':')[0] || '').trim();
      const firstDayName = dayPart.includes('–')
        ? (dayPart.split('–')[0] || dayPart).trim()
        : dayPart;
      parts[parts.length - 1] = slotStr === 'Closed'
        ? `${firstDayName}–${dayName}: Closed`
        : `${firstDayName}–${dayName}: ${slotStr}`;
    } else {
      parts.push(`${dayName}: ${slotStr}`);
    }
  }
  return parts.join('\n');
}

export default formatTimeSlotsByDayToHumanReadable;
